var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAcompanharObra = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "183.953 130.952 89.073 88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_23893_6774",
    x: -6,
    y: 4,
    width: 110.346,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.141176 0 0 0 0 0.14902 0 0 0 0 0.145098 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23893_6774"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23893_6774",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23893_6774",
    x1: 63.7014,
    y1: 55.8606,
    x2: 63.7014,
    y2: 40.7523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D38D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23893_6774",
    x1: 1482.08,
    y1: 1102.28,
    x2: 1208.75,
    y2: 951.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D38D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23893_6774",
    x1: 304.523,
    y1: 249.325,
    x2: 1230.72,
    y2: 249.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D38D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_23893_6774",
    x1: 2691.38,
    y1: 818.521,
    x2: 305.853,
    y2: 818.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_23893_6774",
    x1: 303.95,
    y1: 865.454,
    x2: 1232.99,
    y2: 865.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D38D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_23893_6774",
    x1: 31.9548,
    y1: 44.0941,
    x2: 37.2796,
    y2: 44.0941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_23893_6774",
    x1: 320.983,
    y1: 443.776,
    x2: 431.126,
    y2: 443.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 192.023 141.132 C 189.394 141.132 187.263 143.139 187.263 145.613 L 183.953 214.472 C 183.953 216.946 186.084 218.952 188.713 218.952 L 268.265 218.952 C 270.895 218.952 273.026 216.946 273.026 214.472 L 268.769 135.433 C 268.769 132.958 266.637 130.952 264.008 130.952 L 192.023 141.132 Z",
    fill: "#F7F5F2"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_23893_6774)",
    transform: "matrix(1, 0, 0, 1, 179.952880859375, 130.9521942138672)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23893_6774",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 20,
    width: 63,
    height: 56
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7188 20H80.4623V76H18.7188V20Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23893_6774)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1409 64.0884C31.6242 64.0884 32.8266 62.8881 32.8266 61.4073C32.8266 59.9266 31.6242 58.7263 30.1409 58.7263C28.6575 58.7263 27.4551 59.9266 27.4551 61.4073C27.4551 62.8881 28.6575 64.0884 30.1409 64.0884Z",
    fill: "#727D79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1819 64.0884C38.6652 64.0884 39.8676 62.8881 39.8676 61.4073C39.8676 59.9266 38.6652 58.7263 37.1819 58.7263C35.6986 58.7263 34.4961 59.9266 34.4961 61.4073C34.4961 62.8881 35.6986 64.0884 37.1819 64.0884Z",
    fill: "#727D79"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2229 64.1144C45.7062 64.1144 46.9087 62.914 46.9087 61.4333C46.9087 59.9526 45.7062 58.7522 44.2229 58.7522C42.7396 58.7522 41.5371 59.9526 41.5371 61.4333C41.5371 62.914 42.7396 64.1144 44.2229 64.1144Z",
    fill: "#727D79"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2639 64.1144C52.7472 64.1144 53.9497 62.914 53.9497 61.4333C53.9497 59.9526 52.7472 58.7522 51.2639 58.7522C49.7806 58.7522 48.5781 59.9526 48.5781 61.4333C48.5781 62.914 49.7806 64.1144 51.2639 64.1144Z",
    fill: "#727D79"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4924 64.0987C30.9757 64.0987 32.1782 62.8984 32.1782 61.4177C32.1782 59.9369 30.9757 58.7366 29.4924 58.7366C28.0091 58.7366 26.8066 59.9369 26.8066 61.4177C26.8066 62.8984 28.0091 64.0987 29.4924 64.0987Z",
    fill: "#ACACAC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5334 64.0987C38.0167 64.0987 39.2192 62.8984 39.2192 61.4177C39.2192 59.9369 38.0167 58.7366 36.5334 58.7366C35.0501 58.7366 33.8477 59.9369 33.8477 61.4177C33.8477 62.8984 35.0501 64.0987 36.5334 64.0987Z",
    fill: "#ACACAC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5744 64.1246C45.0578 64.1246 46.2602 62.9243 46.2602 61.4435C46.2602 59.9628 45.0578 58.7625 43.5744 58.7625C42.0911 58.7625 40.8887 59.9628 40.8887 61.4435C40.8887 62.9243 42.0911 64.1246 43.5744 64.1246Z",
    fill: "#ACACAC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6155 64.1246C52.0988 64.1246 53.3012 62.9243 53.3012 61.4435C53.3012 59.9628 52.0988 58.7625 50.6155 58.7625C49.1321 58.7625 47.9297 59.9628 47.9297 61.4435C47.9297 62.9243 49.1321 64.1246 50.6155 64.1246Z",
    fill: "#ACACAC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6097 26.0098C48.4263 25.7605 48.1922 25.5527 47.9228 25.4001C47.6533 25.2474 47.3546 25.1533 47.0461 25.124C46.7377 25.0947 46.4265 25.1308 46.1331 25.2299C45.8396 25.3291 45.5704 25.489 45.3432 25.6992L22.3741 46.8788C22.1544 47.0828 21.9777 47.3286 21.8545 47.6018C21.7313 47.875 21.6642 48.17 21.6569 48.4695C21.6497 48.769 21.7025 49.067 21.8123 49.3458C21.9221 49.6246 22.0867 49.8786 22.2964 50.093L24.9406 52.7741C25.1536 52.9943 25.4102 53.1677 25.694 53.2833C25.9779 53.3989 26.2829 53.454 26.5893 53.4453C26.8958 53.4365 27.197 53.364 27.4738 53.2324C27.7506 53.1008 27.9968 52.9129 28.1968 52.6809L48.5215 28.8151C48.8549 28.4278 49.0454 27.9383 49.0615 27.428C49.0775 26.9176 48.9181 26.4172 48.6097 26.0098Z",
    fill: "#079D56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.625 54.8495C78.818 54.4803 78.9229 54.0715 78.9318 53.6551C78.9406 53.2387 78.8531 52.8259 78.676 52.4487C78.4989 52.0716 78.237 51.7404 77.9107 51.4808C77.5844 51.2212 77.2025 51.0403 76.7948 50.9521C76.8472 50.4236 76.7489 49.8911 76.5111 49.416C76.2733 48.9409 75.9058 48.5426 75.4509 48.2671C74.9961 47.9917 74.4724 47.8502 73.9405 47.8592C73.4085 47.8681 72.89 48.027 72.4446 48.3176C72.2947 47.5837 71.9177 46.9152 71.3669 46.4066C70.816 45.898 70.1191 45.5749 69.3745 45.4828C68.6298 45.3907 67.875 45.5344 67.2165 45.8935C66.558 46.2526 66.029 46.8091 65.7043 47.4843C65.0147 47.1297 64.2265 47.0145 63.4641 47.157C62.7016 47.2994 62.0085 47.6914 61.4941 48.271L65.4295 59.5182",
    fill: "#EDF1F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6669 40.7485L58.5938 41.427L67.7492 55.8563L68.8224 55.1778L59.6669 40.7485Z",
    fill: "#079D56"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M59.6669 40.7485L58.5938 41.4271L67.7492 55.8564L68.8224 55.1779L59.6669 40.7485Z",
    fill: "url(#paint0_linear_23893_6774)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.166 25.8648L63.0228 57.5255L64.8168 56.0503L53.9285 21.3722C53.8379 21.0838 53.6779 20.8218 53.4626 20.6093C53.2473 20.3967 52.9832 20.2399 52.6933 20.1527C52.4034 20.0654 52.0965 20.0502 51.7994 20.1085C51.5022 20.1668 51.2239 20.2968 50.9886 20.4871L45.166 25.8648Z",
    fill: "#006B3F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.043 65.9672L67.9911 53.716L62.8633 57.3391C62.8633 57.3391 64.2373 62.6443 68.043 65.9672Z",
    fill: "#079D56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0413 65.9673C68.0413 65.9673 79.7436 68.4207 80.3451 53.861C80.3453 53.7281 80.2942 53.6002 80.2025 53.5039C80.1108 53.4075 79.9855 53.3501 79.8525 53.3434L78.4319 53.3072C78.3037 53.3064 78.1798 53.3531 78.084 53.4381C77.9883 53.5232 77.9275 53.6407 77.9134 53.7678L77.8719 54.2854C77.8578 54.4126 77.797 54.5301 77.7013 54.6151C77.6055 54.7002 77.4816 54.7468 77.3534 54.7461L76.3631 54.7512C76.231 54.7433 76.107 54.6853 76.0164 54.5891C75.9258 54.4929 75.8755 54.3657 75.8757 54.2337V53.8351C75.8762 53.7056 75.8281 53.5805 75.7407 53.4847C75.6533 53.3888 75.5332 53.3292 75.4039 53.3175L74.3669 53.2554C74.2346 53.2552 74.1072 53.3054 74.0109 53.3959C73.9145 53.4863 73.8564 53.6101 73.8484 53.742V54.0629C73.8484 54.2001 73.7938 54.3318 73.6966 54.4288C73.5993 54.5259 73.4674 54.5804 73.3299 54.5804L72.5729 54.5442C72.4372 54.5336 72.3111 54.4701 72.2218 54.3675C72.1326 54.2648 72.0873 54.1312 72.0959 53.9956V53.7264C72.1002 53.6559 72.0899 53.5852 72.0658 53.5188C72.0416 53.4524 72.0041 53.3916 71.9555 53.3402C71.9069 53.2888 71.8483 53.2479 71.7833 53.2199C71.7183 53.192 71.6482 53.1777 71.5774 53.1778H70.3849C70.2614 53.176 70.1413 53.2183 70.0462 53.297C69.9512 53.3758 69.8874 53.4859 69.8664 53.6074C69.8249 53.8972 67.9688 53.7678 67.9688 53.7678",
    fill: "#00D38D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M68.0424 65.9673C68.0424 65.9673 79.7447 68.4207 80.3462 53.861C80.3463 53.7281 80.2953 53.6002 80.2036 53.5039C80.1119 53.4075 79.9866 53.3501 79.8536 53.3434L78.4329 53.3072C78.3047 53.3064 78.1808 53.3531 78.0851 53.4381C77.9893 53.5232 77.9285 53.6407 77.9144 53.7678L77.873 54.2854C77.8589 54.4126 77.7981 54.5301 77.7023 54.6151C77.6066 54.7002 77.4827 54.7468 77.3545 54.7461L76.3642 54.7512C76.2321 54.7433 76.1081 54.6853 76.0175 54.5891C75.9269 54.4929 75.8765 54.3657 75.8768 54.2337V53.8351C75.8773 53.7056 75.8291 53.5805 75.7418 53.4847C75.6544 53.3888 75.5342 53.3292 75.405 53.3175L74.368 53.2554C74.2357 53.2552 74.1083 53.3054 74.0119 53.3959C73.9155 53.4863 73.8574 53.6101 73.8495 53.742V54.0629C73.8495 54.2001 73.7949 54.3318 73.6976 54.4288C73.6004 54.5259 73.4685 54.5804 73.331 54.5804L72.574 54.5442C72.4383 54.5336 72.3121 54.4701 72.2229 54.3675C72.1336 54.2648 72.0884 54.1312 72.097 53.9956V53.7264C72.1012 53.6559 72.091 53.5852 72.0668 53.5188C72.0427 53.4524 72.0052 53.3916 71.9566 53.3402C71.908 53.2888 71.8494 53.2479 71.7844 53.2199C71.7194 53.192 71.6493 53.1777 71.5785 53.1778H70.386C70.2625 53.176 70.1424 53.2183 70.0473 53.297C69.9522 53.3758 69.8885 53.4859 69.8675 53.6074C69.826 53.8972 67.7935 53.7316 67.9698 53.7678",
    fill: "url(#paint1_linear_23893_6774)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5081 47.4481H21.4508C20.0563 47.4481 18.9258 48.5766 18.9258 49.9687V51.9614C18.9258 53.3535 20.0563 54.482 21.4508 54.482H29.5081C30.9027 54.482 32.0332 53.3535 32.0332 51.9614V49.9687C32.0332 48.5766 30.9027 47.4481 29.5081 47.4481Z",
    fill: "#006B3F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1302 56.9769C46.4113 56.0724 46.8559 55.2269 47.4419 54.4821H25.5254C25.5254 54.4821 27.1794 56.1694 27.1483 57.2978",
    fill: "#079D56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1302 56.9769C46.4113 56.0724 46.8559 55.2269 47.4419 54.4821H25.5254C25.5254 54.4821 27.1794 56.1694 27.1483 57.2978",
    fill: "#079D56"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M46.1302 56.9769C46.4113 56.0724 46.8559 55.2269 47.4419 54.4821H25.5254C25.5254 54.4821 27.1794 56.1694 27.1483 57.2978",
    fill: "url(#paint2_linear_23893_6774)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4876 66.2002H27.869C26.6026 66.2002 25.3879 65.698 24.4924 64.804C23.5969 63.91 23.0938 62.6975 23.0938 61.4333C23.0938 60.169 23.5969 58.9565 24.4924 58.0625C25.3879 57.1686 26.6026 56.6663 27.869 56.6663H53.4876C54.1147 56.6663 54.7356 56.7896 55.315 57.0292C55.8944 57.2687 56.4208 57.6199 56.8642 58.0625C57.3077 58.5052 57.6594 59.0307 57.8994 59.609C58.1394 60.1874 58.2629 60.8073 58.2629 61.4333C58.2629 62.0593 58.1394 62.6792 57.8994 63.2575C57.6594 63.8359 57.3077 64.3614 56.8642 64.804C56.4208 65.2467 55.8944 65.5978 55.315 65.8374C54.7356 66.0769 54.1147 66.2002 53.4876 66.2002ZM27.869 58.7729C27.1832 58.8031 26.5356 59.0963 26.061 59.5915C25.5864 60.0866 25.3215 60.7454 25.3215 61.4307C25.3215 62.116 25.5864 62.7748 26.061 63.2699C26.5356 63.765 27.1832 64.0583 27.869 64.0885H53.4876C54.1734 64.0583 54.8211 63.765 55.2956 63.2699C55.7702 62.7748 56.0351 62.116 56.0351 61.4307C56.0351 60.7454 55.7702 60.0866 55.2956 59.5915C54.8211 59.0963 54.1734 58.8031 53.4876 58.7729H27.869Z",
    fill: "#ACACAC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.63,
    d: "M53.4876 66.2002H27.869C26.6026 66.2002 25.3879 65.698 24.4924 64.804C23.5969 63.91 23.0938 62.6975 23.0938 61.4333C23.0938 60.169 23.5969 58.9565 24.4924 58.0625C25.3879 57.1686 26.6026 56.6663 27.869 56.6663H53.4876C54.1147 56.6663 54.7356 56.7896 55.315 57.0292C55.8944 57.2687 56.4208 57.6199 56.8642 58.0625C57.3077 58.5052 57.6594 59.0307 57.8994 59.609C58.1394 60.1874 58.2629 60.8073 58.2629 61.4333C58.2629 62.0593 58.1394 62.6792 57.8994 63.2575C57.6594 63.8359 57.3077 64.3614 56.8642 64.804C56.4208 65.2467 55.8944 65.5978 55.315 65.8374C54.7356 66.0769 54.1147 66.2002 53.4876 66.2002ZM27.869 58.7729C27.1832 58.8031 26.5356 59.0963 26.061 59.5915C25.5864 60.0866 25.3215 60.7454 25.3215 61.4307C25.3215 62.116 25.5864 62.7748 26.061 63.2699C26.5356 63.765 27.1832 64.0583 27.869 64.0885H53.4876C54.1734 64.0583 54.8211 63.765 55.2956 63.2699C55.7702 62.7748 56.0351 62.116 56.0351 61.4307C56.0351 60.7454 55.7702 60.0866 55.2956 59.5915C54.8211 59.0963 54.1734 58.8031 53.4876 58.7729H27.869Z",
    fill: "url(#paint3_linear_23893_6774)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4785 54.4821V52.1219C25.4795 51.4829 25.6876 50.8613 26.0717 50.3501C26.4558 49.8388 26.9952 49.4654 27.6095 49.2855L28.7087 48.9646C29.2243 48.815 29.6896 48.5285 30.0548 48.1356C30.4201 47.7428 30.6716 47.2583 30.7827 46.7338L32.0789 40.5228C32.2158 39.8521 32.5816 39.2496 33.114 38.8182C33.6464 38.3868 34.3123 38.1533 34.998 38.1575H44.476C44.8652 38.1568 45.2507 38.2327 45.6105 38.3809C45.9703 38.5292 46.2973 38.7467 46.5728 39.0213C46.8482 39.2958 47.0668 39.6218 47.2159 39.9807C47.365 40.3396 47.4417 40.7243 47.4417 41.1129V54.4821",
    fill: "#00D38D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4767 38.1574H34.9987C34.318 38.1575 33.6582 38.3918 33.1303 38.8207C32.6024 39.2497 32.2386 39.8471 32.1004 40.5124L30.8041 46.7234C30.6931 47.2479 30.4416 47.7324 30.0763 48.1252C29.711 48.5181 29.2458 48.8046 28.7302 48.9542L27.631 49.2751C27.0167 49.455 26.4772 49.8284 26.0931 50.3397C25.7091 50.8509 25.501 51.4725 25.5 52.1115V54.4717H47.4425V41.1128C47.4425 40.7243 47.3657 40.3395 47.2166 39.9806C47.0675 39.6217 46.849 39.2957 46.5735 39.0212C46.298 38.7467 45.971 38.5291 45.6113 38.3809C45.2515 38.2327 44.8659 38.1567 44.4767 38.1574Z",
    fill: "#00D38D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M44.4974 38.1574H34.9987C34.318 38.1575 33.6582 38.3918 33.1303 38.8207C32.6024 39.2497 32.2386 39.8471 32.1004 40.5124L30.8041 46.7234C30.6942 47.2483 30.443 47.7334 30.0776 48.1264C29.7122 48.5195 29.2463 48.8056 28.7302 48.9542L27.6258 49.2751C27.0125 49.4559 26.4742 49.8298 26.0911 50.3409C25.708 50.8521 25.5006 51.4731 25.5 52.1115V54.4717H47.4425V41.1128C47.4425 40.3317 47.1327 39.5823 46.5808 39.0285C46.029 38.4747 45.2799 38.1615 44.4974 38.1574Z",
    fill: "url(#paint4_linear_23893_6774)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.345 39.7412C34.157 39.7406 33.9745 39.8046 33.8282 39.9224C33.6819 40.0402 33.5806 40.2047 33.5413 40.3882L31.9859 47.448C31.9595 47.5681 31.9605 47.6925 31.9886 47.8121C32.0167 47.9317 32.0713 48.0435 32.1484 48.1393C32.2255 48.2351 32.3231 48.3125 32.434 48.3657C32.545 48.419 32.6664 48.4467 32.7895 48.447H37.2796V39.7412H34.345Z",
    fill: "#EDF1F0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M34.345 39.7412C34.157 39.7406 33.9745 39.8046 33.8282 39.9224C33.6819 40.0402 33.5806 40.2047 33.5413 40.3882L31.9859 47.448C31.9595 47.5681 31.9605 47.6925 31.9886 47.8121C32.0167 47.9317 32.0713 48.0435 32.1484 48.1393C32.2255 48.2351 32.3231 48.3125 32.434 48.3657C32.545 48.419 32.6664 48.4467 32.7895 48.447H37.2796V39.7412H34.345Z",
    fill: "url(#paint5_linear_23893_6774)"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8093 42.9399C45.7944 42.0863 45.4442 41.2728 44.8342 40.6745C44.2242 40.0763 43.4032 39.7411 42.548 39.7412H38.3379V48.447H45.0782C45.296 48.4429 45.5033 48.353 45.6548 48.1968C45.8064 48.0407 45.8899 47.8311 45.8871 47.6137L45.8093 42.9399Z",
    fill: "#EDF1F0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M45.8093 42.9399C45.7944 42.0863 45.4442 41.2728 44.8342 40.6745C44.2242 40.0763 43.4032 39.7411 42.548 39.7412H38.3379V48.447H45.0782C45.296 48.4429 45.5033 48.353 45.6548 48.1968C45.8064 48.0407 45.8899 47.8311 45.8871 47.6137L45.8093 42.9399Z",
    fill: "url(#paint6_linear_23893_6774)"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.867 49.9791H37.8039C37.7008 49.9791 37.6172 50.0625 37.6172 50.1654V50.3207C37.6172 50.4237 37.7008 50.5071 37.8039 50.5071H38.867C38.9701 50.5071 39.0537 50.4237 39.0537 50.3207V50.1654C39.0537 50.0625 38.9701 49.9791 38.867 49.9791Z",
    fill: "#006B3F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M45.166 25.8648L46.203 31.5013L46.2289 31.4806L47.5044 29.9744",
    fill: "#079D56"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAcompanharObra);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/acompanhar_obra.0fe04b6bdfe78e39fd34aba8a2c7b251.svg";